import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ProgressBarProps {
  current: number;
  total: number;
  onBack: () => void;
  onSkip: () => void;
}
export function ProgressBar({
  current,
  total,
  onBack,
  onSkip
}: ProgressBarProps) {
  const progress = (current + 1) / total * 100;
  return <div className="absolute top-0 left-0 w-full z-50" data-id="element-936">
      <div className="h-1 bg-navy-700 w-full" data-id="element-937">
        <motion.div className="h-full bg-teal-400" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-938" />
      </div>
      <div className="flex items-center justify-between px-6 pt-3 pl-44" data-id="element-939">
        <button onClick={onBack} disabled={current === 0} className="flex items-center gap-1 text-sm font-medium text-white/50 hover:text-white transition-colors disabled:opacity-20 disabled:cursor-not-allowed" data-id="element-940">
          <ChevronLeftIcon className="w-4 h-4" data-id="element-941" />
          Back
        </button>
        <span className="text-xs font-medium text-white/40 tracking-widest" data-id="element-942">
          {current + 1} / {total}
        </span>
        <button onClick={onSkip} disabled={current === total - 1} className="flex items-center gap-1 text-sm font-medium text-white/50 hover:text-white transition-colors disabled:opacity-20 disabled:cursor-not-allowed" data-id="element-943">
          Skip
          <ChevronRightIcon className="w-4 h-4" data-id="element-944" />
        </button>
      </div>
    </div>;
}